export const colors = {
  PRIMARY: '#009FE2',
  SECONDARY: '#001529',

  BG_COLOR: '#F4F5F7',
  DARKER_GREY_COLOR: '#D6D6D6',
  COLOR_BORDER: '#D3D3D9',

  PRIMARY_HOVER: '#0F7BBF',

  WHITE: '#FFFFFF',
  BLACK: '#000000',
  TRANSPARENT: '#00000000',

  GREEN: '#52C41A',
  RED: '#FF4D4F',
};

export const cssVariables = `
  :root {
    --primary: ${colors.PRIMARY};
    --secondary: ${colors.SECONDARY};
    
    --darker-grey-color: ${colors.DARKER_GREY_COLOR};
    --color-border: ${colors.COLOR_BORDER};
    

    --color-white: ${colors.WHITE};
    --color-black: ${colors.BLACK};
    
    --color-red: ${colors.RED};
    --color-green: ${colors.GREEN};
  }
`;
